export default "__VITE_ASSET__51b0780b__"